import {
  GET_SALE_RA_COLUMN_REQUEST,
  GET_SALE_RA_COLUMN_SUCCESS,
  GET_SALE_RA_COLUMN_ERROR,
    } from "../actions/types";


export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_SALE_RA_COLUMN_REQUEST:
        return {
          loading: true,
        };
      case GET_SALE_RA_COLUMN_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_SALE_RA_COLUMN_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };